const colors = {
  black: '#000',
  white: '#fff',
  snow: '#ededed',
  'egg-shell': '#e1e0dc',
  fossil: '#bebbbb',
  ash: '#787878',
  shadow: '#555354',
  charcoal: '#40423f',
  nero: '#1B1B1B',
  whiteSmoke: '#F5F5F5',
  neutralWhite: '#E7E7E4',
  'light-peach': '#e4dfd4',
  beige: '#dbd4c5',
  'very-light-brown': '#c2b299',
  'desert-rock': '#9d857f',

  '#error-pink': '#ff8787',

  'error-red': '#eb5858',
  'success-green': '#ff8787',
};

export default colors;
